import React, { useState } from "react";
import PropTypes from "prop-types";
import TimeRangeInput from "@/components/specific/Time_Range_Input";
import Calendar from "@/components/specific/Calender";
import Input from "@/components/common/inputs/Input";
import WebIcon from "@/components/common/Web_Icons";

const CustomScheduleInput = ({
  options = [],
  value,
  onChange,
  onCustomDateChange,
  onCustomTimeFromChange,
  onCustomTimeToChange,
  customDate,
  customTimeFrom,
  customTimeTo,
  className = "",
}) => {
  const [, setIsCustomOpen] = useState(false);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isSelectingEndDate, setIsSelectingEndDate] = useState(false);

  const handleDateSelect = (date) => {
    if (!isSelectingEndDate) {
      // Selecting start date
      setSelectedStartDate(date);
      setIsSelectingEndDate(true);
    } else {
      // Selecting end date
      setSelectedEndDate(date);
      setIsCalendarVisible(false);
      setIsSelectingEndDate(false);

      // Format and pass the date range back to parent
      const formattedStartDate = formatDate(selectedStartDate);
      const formattedEndDate = formatDate(date);
      onCustomDateChange(`${formattedStartDate} - ${formattedEndDate}`);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="space-y-4">
      <div className="bg-secondary p-2 rounded-md">
        <div className="flex items-center justify-between gap-1">
          {options.map((option, index) => (
            <React.Fragment key={option.value}>
              <div className="relative flex-1">
                <button
                  type="button"
                  onClick={() => {
                    onChange(option.value);
                    setIsCustomOpen(option.value === "custom");
                  }}
                  className={`
                    w-full px-2 py-1.5 rounded-md text-[10px] font-medium whitespace-nowrap
                    ${
                      value === option.value
                        ? "bg-primary text-white"
                        : "bg-transparent text-gray-500"
                    }
                    transition duration-150 ease-in-out
                    hover:bg-primary hover:text-white
                    ${
                      option.value === "custom" &&
                      "flex items-center justify-center gap-1"
                    }
                    ${className}
                  `}>
                  {option.label}
                </button>
              </div>
              {index < options.length - 1 && (
                <div className="h-6 mx-1 border-l border-dotted border-gray-400"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {value === "custom" && (
        <div className="space-y-4">
          {/* Time Range Input First */}
          <TimeRangeInput
            fromTime={customTimeFrom}
            toTime={customTimeTo}
            onFromChange={onCustomTimeFromChange}
            onToChange={onCustomTimeToChange}
          />

          {/* Date Range Input Below */}
          <div className="space-y-2">
            <Input
              label="SELECT DATE RANGE"
              type="text"
              value={customDate || ""}
              placeholder="Select date range"
              readOnly
              icon={<WebIcon icon="CalendarSearch" size="small" />}
              onClick={() => setIsCalendarVisible(true)}
              className="cursor-pointer"
            />
          </div>

          {/* Calendar Modal */}
          <Calendar
            isVisible={isCalendarVisible}
            onClose={() => {
              setIsCalendarVisible(false);
              setIsSelectingEndDate(false);
            }}
            onDateSelect={handleDateSelect}
            selectedDate={
              isSelectingEndDate ? selectedEndDate : selectedStartDate
            }
            initialDate={new Date()}
          />
        </div>
      )}
    </div>
  );
};

CustomScheduleInput.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func,
  onCustomDateChange: PropTypes.func,
  onCustomTimeFromChange: PropTypes.func,
  onCustomTimeToChange: PropTypes.func,
  customDate: PropTypes.string,
  customTimeFrom: PropTypes.string,
  customTimeTo: PropTypes.string,
  className: PropTypes.string,
};
export default CustomScheduleInput;
